
const rules = {
  mobileRules: [
    { required: true, message: '不可为空' },
    { validator: (val) => {
      // if (!(/^1\d{10}$/.test(val))) {
      if (!(/^[1]\d{10}$/.test(val))) {
        return false
      }
      return true
    },
    message: '格式不正确'
    }
  ],
  codeRules: [
    { required: true, message: '不可为空' },
    { validator: (val) => {
      if (val == undefined || val == '') {
        return false
      }
      if (!(/^\d{6}$/.test(val))) {
        return false
      }
      return true
    },
    message: '格式不正确'
    }
  ],
  idRules: [
    { required: true, message: '不可为空' },
    { validator: (val) => {
      var aCity = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 83: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
      var iSum = 0
      if (!/^\d{17}(\d|x)$/i.test(val)) return false
      val = val.replace(/x$/i, 'a')
      if (aCity[parseInt(val.substr(0, 2))] == null) return false
      var sBirthday = val.substr(6, 4) + '-' + Number(val.substr(10, 2)) + '-' + Number(val.substr(12, 2))
      var d = new Date(sBirthday.replace(/-/g, '/'))
      if (sBirthday != (d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate())) return false
      for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(val.charAt(17 - i), 11)
      if (iSum % 11 != 1) return false
      return true// aCity[parseInt(val.substr(0,2))]+","+sBirthday+","+(val.substr(16,1)%2?"男":"女")
    },
    message: '格式不正确'
    }
  ],
  nameRules: [
    { required: true, message: '不可为空' },
    { validator: (val) => {
      if (!(/^(([\u2E80-\uFE4F]{2,})|([a-zA-Z]{3,})|([a-zA-Z]{2,}(\\s+)[a-zA-Z]{2,})|([\u2E80-\uFE4F]+(•)[\u2E80-\uFE4F]{2,})|[\u2E80-\uFE4F]{2,}(?:·[\u2E80-\uFE4F]{2,})*)$|(^[\u2E80-\uFE4F.·]{1,10}$)/.test(val))) {
        return false
      }
      return true
    },
    message: '格式不正确'
    }
  ],
  passwordRules: [
    { required: true, message: '不可为空' },
    { validator: (val) => {
      const regex = /^(.{6,16})$/
      if (!regex.test(val)) {
        return false
      }
      return true
    },
    message: '请输入6 - 16位密码'
    },
    { validator: (val) => {
      const regex = /^(?![~!?@#$%^&*_,.;'/0-9A-Za-z]+$).*$/
      if (regex.test(val)) {
        return false
      }
      return true
    },
    message: '不能包含特殊字符如+“ ” { }等'
    },
    { validator: (val) => {
      const regex = /^(?:(?=.*[a-zA-Z])(?=.*[0-9])|(?=.*[a-zA-Z])(?=.*[.,;:'"!?])|(?=.*[0-9])(?=.*[.,;:'"!?]))[a-zA-Z0-9.,;:'"!?]{6,16}$/
      if (!regex.test(val)) {
        return false
      }
      return true
    },
    message: '至少包含数字、字母及标点符号中的两种'
    }
  ]

}
export default rules
